
export const EXPORT_TYPE = {
    PDF: "pdf",
    DOC: "doc"
}

export const MAP_EXPORT_PATH = {
    PHIEU_CHI_DINH_KHAM_BENH: "PHIEU_CHI_DINH_KHAM_BENH",
};